import React, { useState, useEffect, useRef } from "react";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
/** Components Import */
import Calendar from "../../Components/Calendar";
import { Loading, Button, Dialog } from "../../Components/Bootstrap";
import { Card, Stack } from "react-bootstrap";

function AddWork() {
  const [loading, setLoading] = useState(false);
  const [dateValue, setDateValue] = useState(new Date());
  const [holidayList, setHolidayList] = useState([]);
  const [myWorkList, setMyWorkList] = useState([]);
  const [workDetailList, setWorkDetailList] = useState([]);
  const [dialogToggle, setDialogToggle] = useState(false);
  const [dialogDateValue, setDialogDateValue] = useState(new Date());
  const [dialogToggle1, setDialogToggle1] = useState(false);
  const deleteDatas = useRef({});

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      await SelectLogic(); // 휴일 조회
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 휴일 조회
  const SelectLogic = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _holidayList = [];
    let _myWorkList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AddWork.AddWork,
        {
          ym: _ym,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("휴일 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _holidayList.push(Commons.DateFormating(data[i].dt, 2));
            if (data[i].inYn == "Y") {
              _myWorkList.push(Commons.DateFormating(data[i].dt, 2));
            }
          }
          setHolidayList(_holidayList);
          setMyWorkList(_myWorkList);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 근무 신청 상세 조회
  const SelectLogic1 = async (_ym = Commons.DateFormating(new Date(), 8)) => {
    setLoading(true);
    let _workDetailList = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AddWork.GetDetail,
        {
          ym: _ym,
        }
      ).then((result) => {
        let data = result.data;
        // console.log("근무 신청 상세 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          setDialogToggle(false);
          throw new Error("근무 신청 이력이 없습니다.");
        } else if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _workDetailList.push(data[i]);
          }
          setWorkDetailList(_workDetailList);
          setDialogToggle(true);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 근무 신청
  const SaveLogic = async () => {
    setLoading(true);

    try {
      if (
        holidayList.filter((f) => f === Commons.DateFormating(dateValue, 2))
          .length == 0
      ) {
        throw new Error("표시된 휴일 중에 선택해주세요.");
      } else if (
        myWorkList.filter((f) => f === Commons.DateFormating(dateValue, 2))
          .length != 0
      ) {
        throw new Error("이미 신청한 날짜입니다.");
      }

      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.AddWork.Create,
        {
          dt: Commons.DateFormating(dateValue, 6),
          userId: "user",
          seq: 0,
          rstdeDiv: "11",
          processDiv: "0",
        }
      ).then((result) => {
        let data = result.data;
        // console.log("근무 신청: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          SelectLogic();
          Commons.Toast("success", "신청되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 근무 신청 취소
  const DeleteLogic = async (_params) => {
    setLoading(true);

    try {
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.AddWork.Delete,
        _params
      ).then((result) => {
        let data = result.data;
        // console.log("근무 신청 취소: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Ok") {
          setDialogToggle1(false);
          SelectLogic();
          SelectLogic1();
          Commons.Toast("success", "취소되었습니다.");
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Calendar
        myHolidays={holidayList}
        myWorks={myWorkList}
        dateState={dateValue}
        onChange={async (e) => {
          setDateValue(e);
          await SelectLogic(Commons.DateFormating(e, 8));
        }}
        onActiveStartDateChange={(e) =>
          SelectLogic(Commons.DateFormating(e, 8))
        }
      />
      <Card className="mt-3">
        <Card.Body className="input-card-body">
          <p className="input-card-body-notice mb-1">
            - 표시된 일자(휴무일)에서 선택하세요.
          </p>
          <p className="input-card-body-notice mb-1">
            - 근무신청 접수 완료 시 휴무에서 빠집니다.
          </p>
          <p className="input-card-body-notice mb-1">
            - 근무일수 초과시 신청이 안 될 수 있습니다.
          </p>
        </Card.Body>
        <Card.Body className="input-card-body input-card-body___flex_space_between_center">
          <Button
            className="vacation-button___width"
            title="신청"
            onClick={SaveLogic}
          />
          <Button
            className="vacation-button___width"
            title="결과 조회"
            onClick={SelectLogic1}
          />
        </Card.Body>
      </Card>
      <Dialog
        header={false}
        fullscreen
        show={dialogToggle}
        onHide={() => setDialogToggle(false)}
        sumitButton={false}
      >
        <Calendar
          navClassName="custom-react-calendar-nav"
          todayButtonYn={false}
          dateState={dialogDateValue}
          // onChange={(e) => console.log(e)}
          onActiveStartDateChange={(e) =>
            SelectLogic1(Commons.DateFormating(e, 8))
          }
        />
        <Card>
          <Card.Body className="custom-table-grid-header">
            <Stack direction="horizontal">
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-48">
                순번
              </div>
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-208">
                일자
              </div>
              <div className="p-2 custom-table-grid-header-text custom-table-text-width-64">
                승인
              </div>
            </Stack>
          </Card.Body>
        </Card>
        <div className="custom-table-grid-datas">
          {workDetailList.map((item, index) => {
            return (
              <Card key={index}>
                <Card.Body className="custom-table-grid-body">
                  <Stack direction="horizontal">
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-48">
                      {item.num}
                    </div>
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-208">
                      {item.dd}
                    </div>
                    <div className="p-2 custom-table-grid-body-text custom-table-text-width-64">
                      {item.processNm == "신청" ? (
                        <Button
                          size="sm"
                          title="취소"
                          onClick={() => {
                            deleteDatas.current = { ...item };
                            setDialogToggle1(true);
                          }}
                        />
                      ) : (
                        item.processNm
                      )}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </Dialog>
      <Dialog
        title="교육 취소"
        show={dialogToggle1}
        onHide={() => setDialogToggle1(false)}
        sumitButtonName="확인"
        onSumit={() => DeleteLogic(deleteDatas.current)}
      >
        <p>{`${deleteDatas.current.dd}일 근무 신청을`}</p>
        <p>취소하시겠습니까?</p>
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default AddWork;
